import { ionAdPageInfo } from '../../constants/pageInfo/pageInfo.constant';

/**
 * 아이온 광고 페이지에서 넘어온 진입인지 확인한다.
 *
 * 아이온 광고 페이지가 `?from=ion`을 붙여주면 그 값을 우선 사용하고,
 * 붙지 않은 경우 referrer로 보조 판별한다.
 * (referrer는 no-referrer 정책이거나 새 탭으로 열린 경우 비어있을 수 있어 단독 기준으로 쓰지 않는다)
 */
export const checkIsEnteredFromIonAdPage = ({ search }: { search: string }) => {
  if (new URLSearchParams(search).get('from') === ionAdPageInfo.fromQueryParamValue) {
    return true;
  }

  try {
    return new URL(document.referrer).origin === ionAdPageInfo.origin;
  } catch {
    // referrer가 비어있으면 URL 생성에 실패한다
    return false;
  }
};
